module.exports = __webpack_public_path__ + "img/ExhibitSpecialLeftTop.4d687d60.png";